import {
  DocumentLocale,
  SubscriptionPlanDetailsUiModuleBody,
  SubscriptionPlanDetailsUiModuleBodyModuleTypeEnum
} from '../../../API';
import generateId from '../../../utils/generateId';
import { NewModuleFunction } from '../../../utils/layouts';

export const blankSubscriptionPlanDetailsModule: NewModuleFunction<SubscriptionPlanDetailsUiModuleBody> = (module) => ({
  title: {
    [DocumentLocale.ES]: ''
  },
  moduleType: SubscriptionPlanDetailsUiModuleBodyModuleTypeEnum.SUBSCRIPTION_PLAN_DETAILS,
  moduleId: generateId(),
  priceTitle: '',
  price: '',
  deviceLimitTitle: '',
  deviceLimit: '',
  adsDisclaimerTitle: '',
  adsDisclaimer: '',
  contentDisclaimerTitle: '',
  contentDisclaimer: '',
  downloadDisclaimerTitle: '',
  downloadDisclaimer: '',
  valuePropositionTitle: '',
  valueProposition: '',
  legalDisclosure: '',
  planTitle: '',
  planSubtitle: '',
  sportsDisclaimerTitle: '',
  sportsDisclaimer: '',
  ...module
});
